import { useContext } from "react";
import { PaymentFormContext } from "../../../Shared/components/PaymentForm/PaymentFormContext";
import { UpdateOrderDeliveryPickupModalContext } from "../deliveryModalUtils/UpdateOrderDeliveryPickupModalContext";
import { TabNames, UpdateOrderTexts } from "../deliveryModalUtils/const-enums-types";
import { useGetConfigurableTextSettings } from "../hooks/useGetConfigurableTextSettings";
export const useTabComponent = (tabName, flowSku, shouldDisplayPaymentForm) => {
    const { configurableTextSettings, loading: configurableTextLoading } = useGetConfigurableTextSettings(flowSku);
    const { setTabValue, newAddressData, setNewAddressData, tabValue } = useContext(UpdateOrderDeliveryPickupModalContext);
    const { balance } = useContext(PaymentFormContext);
    const shouldDisplayAddresses = tabName !== TabNames.ADD_NEW_ADDRESS && !shouldDisplayPaymentForm;
    const deliveryOrPickupWarning = tabName === TabNames.DELIVERY
        ? configurableTextSettings === null || configurableTextSettings === void 0 ? void 0 : configurableTextSettings.DeliveryModalDeliveryDescription
        : tabName === TabNames.PICKUP
            ? configurableTextSettings === null || configurableTextSettings === void 0 ? void 0 : configurableTextSettings.DeliveryModalPickupDescription
            : UpdateOrderTexts.UPDATE_ORDER_WARNING;
    return {
        configurableTextLoading,
        deliveryOrPickupWarning,
        newAddressData,
        balance,
        tabValue,
        setNewAddressData,
        setTabValue,
        shouldDisplayAddresses,
    };
};
